import React from 'react';
import { Button, Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { setIsHtml } from '../../store/actions';
import { BiEdit } from 'react-icons/bi';

const Btn = (props) => <Button {...props} />;

const OpenEditor = ({ className }) => {
  const dispatch = useDispatch();

  const handleBtnClick = () => {
    dispatch(setIsHtml(true));
  };

  return (
    <Tooltip title="Открыть редактор текста">
      <Btn className={className} onClick={handleBtnClick}>
        <BiEdit />
      </Btn>
    </Tooltip>
  );
};

export default OpenEditor;
